// angular
import {Injectable, inject} from "@angular/core";
import {Title} from "@angular/platform-browser";
import {RouterStateSnapshot, TitleStrategy} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";

@Injectable()
export class CustomTitleStrategy extends TitleStrategy {
  private readonly _title = inject(Title);
  private readonly _translateService = inject(TranslateService);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    // get the deepest child route
    let route = snapshot.root;
    while (route.firstChild) {
      route = route.firstChild;
    }

    // get pageTitle from data
    const pageTitle = route.data?.["pageTitle"];
    if (pageTitle) {
      this._translateService
        .get(pageTitle)
        .subscribe((translatedTitle: string) => {
          this._title.setTitle(translatedTitle);
        });
    } else {
      // fallback to the title property if pageTitle is not present
      const title = this.buildTitle(snapshot);
      if (title) {
        this._title.setTitle(title);
      }
    }
  }
}
